import { render, staticRenderFns } from "./CustomerAppStats.vue?vue&type=template&id=789918cd&scoped=true"
import script from "./CustomerAppStats.vue?vue&type=script&lang=js"
export * from "./CustomerAppStats.vue?vue&type=script&lang=js"
import style1 from "./CustomerAppStats.vue?vue&type=style&index=1&id=789918cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789918cd",
  null
  
)

export default component.exports